import { Icon, Typography, Checkbox, Menu, CircularProgress } from "@ann/web-components";
import { ItemWrapper, ItemLeft, MenuIconWrapper } from "./Item.styled";
import { useState, useEffect, useRef } from "react";
import { ModalBase } from "../../../../components/Modal";

const DriveItem = ({ vaultUuid, name, selectMode, onSelect, selectedItems, setShowSlideoutDriveDetail, removeAccessLoading }) => {

    const [showMenu, setShowMenu] = useState(false);
    const [showRemoveAccessModal, setShowRemoveAccessModal] = useState(false);
    const [removingAccess, setRemovingAccess] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        if (showMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showMenu]);
    const handleMenuClick = () => {
        setShowMenu(!showMenu);
    }

    const handleRemoveAccessClick = () => {
        setShowRemoveAccessModal(true);
        setShowMenu(false);
    }

    const handleRemoveAccess = () => {
        setShowRemoveAccessModal(false);
    }
    useEffect(() => {
        if (removeAccessLoading & selectedItems.includes(vaultUuid)) {
            setRemovingAccess(true);
        }
        else {
            setRemovingAccess(false);
        }
    }, [removeAccessLoading]);

    return (
        <>
            <ItemWrapper disabled={removingAccess}>
                <ItemLeft>
                    {selectMode && (
                        <Checkbox
                            onChange={() => onSelect(vaultUuid)}
                            size="medium"
                            checked={selectedItems.includes(vaultUuid)}
                            disabled={true}
                        />
                    )}
                    <Icon name="folder" size="medium" />
                    <Typography category="subtitle" size="small" weight="bold" color="subtitle">
                        {name}
                    </Typography>
                </ItemLeft>
                <MenuIconWrapper onClick={handleMenuClick}>
                    {removingAccess ? <CircularProgress /> : <Icon name="dotsMenu" />}
                </MenuIconWrapper>
                {showMenu && (<Menu className="add-menu" width="260px">
                    <div ref={menuRef}>
                        <Menu.Item id="Remove-access" title='Remove access' onClick={handleRemoveAccessClick} />
                        <Menu.Item id="View-details " title='View details ' onClick={() => setShowSlideoutDriveDetail(true)} />

                    </div>
                </Menu>)}
            </ItemWrapper>

            {showRemoveAccessModal && (
                <ModalBase
                    isOpen={showRemoveAccessModal}
                    onClose={() => setShowRemoveAccessModal(false)}
                    onClick={handleRemoveAccess}
                    title={`Are you sure you want to remove access?`}
                    description={"Your agent won’t be able to use it for responses until you reconnect it."}
                    buttonTitle="Remove access"
                    disabled={true}
                    modalWidth="571px" />
            )}
        </>
    )
}

export default DriveItem;